import React from "react";
import { IconButton, Text, Stack } from "@fluentui/react";
import { useNavigate } from "react-router-dom";

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  backPath?: string;
  backText?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  backPath,
  backText = "Back",
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <Stack
      horizontal
      verticalAlign="center"
      styles={{
        root: {
          marginBottom: "16px",
          padding: "12px 0",
          borderBottom: "1px solid #e1e5e9",
        },
      }}
    >
      {backPath && (
        <IconButton
          iconProps={{ iconName: "Back" }}
          title={backText}
          onClick={handleBack}
          styles={{
            root: {
              marginRight: "12px",
              width: 40,
              height: 40,
            },
            rootHovered: { backgroundColor: "#f3f2f1" },
            icon: { fontSize: 18, color: "#0078d4" },
            rootPressed: { backgroundColor: "#e1dfdd" },
          }}
        />
      )}
      <Stack>
        <Text
          variant="xLarge"
          styles={{
            root: {
              fontWeight: "600",
              color: "#323130",
              marginBottom: subtitle ? "4px" : "0",
            },
          }}
        >
          {title}
        </Text>
        {subtitle && (
          <Text
            variant="medium"
            styles={{
              root: {
                color: "#605e5c",
                fontWeight: "400",
              },
            }}
          >
            {subtitle}
          </Text>
        )}
      </Stack>
    </Stack>
  );
};

export default PageHeader;
